export default class {
	private counters = [];

	constructor() {}

	public tick() {
		const deltaTime = (window as any).deltaTime;

		let i = 0;
		while (i < this.counters.length) {
			this.counters[i].frames -= deltaTime;
			let remove = false;

			if (this.counters[i].frames <= 0) {
				let canTrigger = true;

				if (this.counters[i].conditionCheckFunc) {
					canTrigger = this.counters[i].conditionCheckFunc();
					if (canTrigger) {
						this.counters[i].repeats = 0;
					}
				}

				if (canTrigger) {
					this.counters[i].func();
				}

				this.counters[i].frames = this.counters[i].frameCount;

				if (this.counters[i].repeats != -1) {
					if (this.counters[i].repeats == 0) {
						remove = true;
					} else {
						this.counters[i].repeats--;
					}
				}
			}

			if (remove) {
				this.counters[i].func = null;
				this.counters.splice(i, 1);
			} else {
				i++;
			}
		}
	}

	public addConditionCheck(
		conditionCheck: CallableFunction,
		func: CallableFunction,
		timeMs: number,
		id: string = null
	) {
		this.add(func, timeMs, -1, id, conditionCheck);
	}

	public add(
		func: CallableFunction,
		timeMs: number,
		repeats: number = 0,
		id: string = null,
		conditionCheck: CallableFunction = null
	) {
		if (timeMs === 0) {
			func();
			return;
		}

		const frameCount = timeMs / 16.66;

		this.counters.push({
			func: func,
			frames: frameCount,
			frameCount: frameCount,
			repeats: repeats,
			id: id,
			conditionCheckFunc: conditionCheck
		});
	}

	public clear() {
		this.counters.forEach((counter) => {
			counter.func = null;
		});

		this.counters = [];
	}

	public clearById(id: string) {
		for (let index = 0; index < this.counters.length; index++) {
			if (this.counters[index].id === id) {
				this.counters[index].func = null;
				this.counters.splice(index, 1);
				return;
			}
		}
	}
}
